
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 810 540"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0 0v1h.5z","transform":"rotate(18 3.157 -.5)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('g',{attrs:{"id":"c"}},[_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"scale(-1 1)"}})])]),_c('path',{attrs:{"fill":"#039","d":"M0 0h810v540H0z"}}),_c('g',{attrs:{"fill":"#fc0","transform":"matrix(30 0 0 30 405 270)"}},[_c('use',{attrs:{"xlink:href":"#d","y":"-6"}}),_c('use',{attrs:{"xlink:href":"#d","y":"6"}}),_c('g',{attrs:{"id":"e"}},[_c('use',{attrs:{"xlink:href":"#d","x":"-6"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(-144 -2.344 -2.11)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(144 -2.11 -2.344)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(72 -4.663 -2.076)"}}),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(72 -5.076 .534)"}})]),_c('use',{attrs:{"xlink:href":"#e","transform":"scale(-1 1)"}})])])
          )
        }
      }
    